var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChevUpPrimary({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 7",
    width: 12,
    height: 7,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-chev-down-primary-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: none;stroke: #FA6284;stroke-linecap: round;stroke-linejoin: round;stroke-width: 2 }\n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m1 6l5-5 5 5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevUpPrimary);
export default __webpack_public_path__ + "static/media/icon-chev-up-primary.a4f6ecfc664cea36c8f371eb7aab0772.svg";
export { ForwardRef as ReactComponent };